<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="ticketForm" class="col-12">
            <div class="row p-0">
                <mat-form-field class="col-12" appearance="outline">
                    <mat-label>Choose Type</mat-label>
                    <mat-select formControlName="category" matTooltip="Category for this ticket." required>
                        <mat-option *ngFor="let request of type" [value]="request.R_RequestType_ID">
                            {{request.Name}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="ticketForm.get('category')?.hasError('required')">
                        Type is required.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row p-0">
                <mat-form-field class="col-12" appearance="outline">
                    <mat-label>Subject</mat-label>
                    <input matInput placeholder="Enter the subject of this ticket"
                        matTooltip="Provide a concise subject or title for this ticket." formControlName="subject"
                        required>
                    <mat-error *ngIf="ticketForm.get('subject')?.hasError('required')">
                        Subject is required.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row p-0">
                <mat-form-field class="col-12" appearance="outline">
                    <mat-label>Description</mat-label>
                    <textarea matInput placeholder="Enter a detailed description"
                        matTooltip="Provide a detailed description of the ticket or issue."
                        formControlName="description" required rows="2"></textarea>
                    <mat-error *ngIf="ticketForm.get('description')?.hasError('required')">
                        Description is required.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="btn btn-success yes-button" [disabled]="ticketForm.invalid" (click)="save()"
            *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>{{data.confirmText}}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>